import { computed, ref } from 'vue'

import axios from 'axios'

const noncompliance_model_natures_of_risk = ref([])
const noncompliance_model_category_filters = ref({})
const filtered_noncompliance_model_natures_of_risk = ref([])

export default function useNoncomplianceModelNaturesOfRisk() {
  const listNoncomplianceModelNaturesOfRisk = async () => {
    axios
      .get('/api/noncompliance_model_natures_of_risk/all')
      .then(function (response) {
        noncompliance_model_natures_of_risk.value =
          filtered_noncompliance_model_natures_of_risk.value =
            response.data.data
      })
      .catch(function () {})
  }

  return {
    noncompliance_model_natures_of_risk: computed(
      () => noncompliance_model_natures_of_risk.value,
    ),
    noncompliance_model_category_filters: noncompliance_model_category_filters,
    filtered_noncompliance_model_natures_of_risk: computed(
      () => filtered_noncompliance_model_natures_of_risk.value,
    ),
    listNoncomplianceModelNaturesOfRisk,
  }
}
